import React, { useEffect } from 'react';
import { format, fromUnixTime } from 'date-fns';
import { he } from 'date-fns/locale';
import { actions, selectors } from './model';
import { useActions } from '../../common/store-utils/hooks';
import { convertDate } from '@common/utils';

export const useCurrentTime = () => {
  const { getTime } = useActions(actions);

  useEffect(() => {
    getTime();
  }, []);

  const currentTime = selectors.useCurrentTime();

  return currentTime;
};

export const useIsUserAgeAbove30 = (birthday: string) => {
  const { getTime } = useActions(actions);

  useEffect(() => {
    getTime();
  }, []);

  // find the date 18 years ago
  const date18YrsAgo = new Date();
  const dateOfBirth = new Date(birthday);
  date18YrsAgo.setFullYear(date18YrsAgo.getFullYear() - 18);
  // check if the date of birth is before that date
  return dateOfBirth <= date18YrsAgo;

};
